export const GLOBAL_VARIABLES_SLUG = 'variaveis-globais'

export const SELECT_STYLES = {
  control: (provided: any) => ({
    ...provided,
    backgroundColor: 'rgba(255, 255, 255, 0)',
    fontSize: '0.875rem',
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#2B4786',
    '&:hover': {
      color: '#1D2C3F',
    },
  }),
}
